<template>
	<!-- mobile user menu -->
	<div class="navbar-nav mt-3">
		<!--
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('Mojerezervacije')" class="nav-item nav-link" href="/vendor#Mojerezervacije"><span class="fas fa-calendar fa-fw"></span>Moje rezervacije</a>
		</li>
		-->
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('Omiljenisalon')" class="nav-item nav-link" href="/user#Omiljenisalon"><span class="fas fa-heart fa-fw"></span>Omiljeni saloni</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('Mojikomentari')" class="nav-item nav-link" href="/user#Mojikomentari"><span class="far fa-comments fa-fw"></span>Moji komentari</a>
		</li>
		<!-- @click="openPage('nadzorna')" <a class="nav-item nav-link" href="/user#userpromo"><span class="fas fa-tags fa-fw"></span>Promo bodovi</a> -->
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('postavke')" class="nav-item nav-link" href="/user#postavke"><span class="fas fa-cog fa-fw"></span>Postavke profila</a>
		</li>
		<div class="dropdown-divider"></div>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="logoutNow($event)" class="nav-item nav-link" href="/user#"><span class="fas fa-sign-out-alt fa-fw"></span>Odjavi se</a>
		</li>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: (state) => state.user
			})
		},
		methods: {
			logoutNow(e) {
				e.preventDefault();
				this.$store.commit('logout');
				window.location.href = '/';
			},
			openPage(page) {
				setTimeout(() => {
					document.getElementById(page).click();
				}, 500);
			},
			toggle() {
				document.getElementById('toggler').click();
			},
		},
		mounted() {}
	}

</script>
<style scoped>
	.nav-item {
		color: black !important;
	}

	.nav-item span {
		margin-right: 10px;
	}

	#login-container a {
		color: black !important;
	}

</style>
